// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1F_q2","col":"CardReaderDesc_col__2Kh9J","label":"CardReaderDesc_label__24XIc"};